import { NotificationsPage } from "../../features/notifications";

export function AdminNotificationsPage() {
  return <NotificationsPage />;
}
